//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Request device
 * @param serialNumber (optional) Serial number of the desired  device (seriennummer)
 * @param serviceProduct (optional) Service product number (serprod)
Using when we want to select between device with same serial number
 * @param failureDuringTherapy (optional) Failure during therapy (kybausfther)
 * @param noFailureDuringTherapy (optional) No failure during therapy (kybnausfther)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function requestDevice(serialNumber?: string | undefined, serviceProduct?: string | null | undefined, failureDuringTherapy?: boolean | null | undefined, noFailureDuringTherapy?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.WarrantyResponseDto> {
    let url_ = getBaseUrl() + "/api/warranty-request?";
    if (serialNumber === null)
        throw new Error("The parameter 'serialNumber' cannot be null.");
    else if (serialNumber !== undefined)
        url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
    if (serviceProduct !== undefined && serviceProduct !== null)
        url_ += "ServiceProduct=" + encodeURIComponent("" + serviceProduct) + "&";
    if (failureDuringTherapy !== undefined && failureDuringTherapy !== null)
        url_ += "FailureDuringTherapy=" + encodeURIComponent("" + failureDuringTherapy) + "&";
    if (noFailureDuringTherapy !== undefined && noFailureDuringTherapy !== null)
        url_ += "NoFailureDuringTherapy=" + encodeURIComponent("" + noFailureDuringTherapy) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
    if (language === null)
        throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRequestDevice,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigRequestDevice?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRequestDevice(_response);
    });
}

function processRequestDevice(response: AxiosResponse): Promise<Types.WarrantyResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initWarrantyResponseDto(resultData200);
        return Promise.resolve<Types.WarrantyResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.WarrantyResponseDto>(null as any);
}

/**
 * Search replacement part nubmer
 * @param replacementPartArticle (optional) replacement part article (tersatzteil)
 */
export function searchReplacementPart(replacementPartArticle?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ReplacementPartResponseDto> {
    let url_ = getBaseUrl() + "/api/warranty-request/replacement-part?";
    if (replacementPartArticle !== undefined && replacementPartArticle !== null)
        url_ += "ReplacementPartArticle=" + encodeURIComponent("" + replacementPartArticle) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearchReplacementPart,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearchReplacementPart?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearchReplacementPart(_response);
    });
}

function processSearchReplacementPart(response: AxiosResponse): Promise<Types.ReplacementPartResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initReplacementPartResponseDto(resultData200);
        return Promise.resolve<Types.ReplacementPartResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ReplacementPartResponseDto>(null as any);
}

/**
 * Add to basket default device
 */
export function addToBasketDefault(request: Types.FillDefaultWarrantyRequestDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/warranty-request/default";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeFillDefaultWarrantyRequestDto(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddToBasketDefault,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAddToBasketDefault?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddToBasketDefault(_response);
    });
}

function processAddToBasketDefault(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Add to basket one of devices with the smae serial number
 */
export function addToBasketWithSameNum(request: Types.FillWarrantyRequestSameNumDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/warranty-request/same-serial-number";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeFillWarrantyRequestSameNumDto(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddToBasketWithSameNum,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAddToBasketWithSameNum?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddToBasketWithSameNum(_response);
    });
}

function processAddToBasketWithSameNum(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Add to basket special device
 */
export function addToBasketSpecial(request: Types.FillSpecialWarrantyRequestDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/warranty-request/special";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddToBasketSpecial,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAddToBasketSpecial?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddToBasketSpecial(_response);
    });
}

function processAddToBasketSpecial(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigRequestDevice: Partial<AxiosRequestConfig> | null;
export function getRequestDeviceRequestConfig() {
  return _requestConfigRequestDevice;
}
export function setRequestDeviceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRequestDevice = value;
}
export function patchRequestDeviceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRequestDevice = patch(_requestConfigRequestDevice ?? {});
}

let _requestConfigSearchReplacementPart: Partial<AxiosRequestConfig> | null;
export function getSearchReplacementPartRequestConfig() {
  return _requestConfigSearchReplacementPart;
}
export function setSearchReplacementPartRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearchReplacementPart = value;
}
export function patchSearchReplacementPartRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearchReplacementPart = patch(_requestConfigSearchReplacementPart ?? {});
}

let _requestConfigAddToBasketDefault: Partial<AxiosRequestConfig> | null;
export function getAddToBasketDefaultRequestConfig() {
  return _requestConfigAddToBasketDefault;
}
export function setAddToBasketDefaultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddToBasketDefault = value;
}
export function patchAddToBasketDefaultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddToBasketDefault = patch(_requestConfigAddToBasketDefault ?? {});
}

let _requestConfigAddToBasketWithSameNum: Partial<AxiosRequestConfig> | null;
export function getAddToBasketWithSameNumRequestConfig() {
  return _requestConfigAddToBasketWithSameNum;
}
export function setAddToBasketWithSameNumRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddToBasketWithSameNum = value;
}
export function patchAddToBasketWithSameNumRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddToBasketWithSameNum = patch(_requestConfigAddToBasketWithSameNum ?? {});
}

let _requestConfigAddToBasketSpecial: Partial<AxiosRequestConfig> | null;
export function getAddToBasketSpecialRequestConfig() {
  return _requestConfigAddToBasketSpecial;
}
export function setAddToBasketSpecialRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddToBasketSpecial = value;
}
export function patchAddToBasketSpecialRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddToBasketSpecial = patch(_requestConfigAddToBasketSpecial ?? {});
}